import React from 'react';
import PropTypes from 'prop-types';
import { StyledCard } from './style';

const CardEasyFast = ({
    number,
	text,
	classComponent,
}) => (
	<StyledCard className={classComponent}>
		<div className="content-header">
			<p>{number}</p>
		</div>
		<div className="content-body">{text}</div>
	</StyledCard>
);

PropTypes.Card = {
	icon: PropTypes.element,
	altIcon: PropTypes.string,
	titleIcon: PropTypes.string,
	title: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	classComponent: PropTypes.string,
};

export default CardEasyFast;
